import { render } from "./RecipeManager.vue?vue&type=template&id=bec67350&scoped=true"
import script from "./RecipeManager.vue?vue&type=script&lang=js"
export * from "./RecipeManager.vue?vue&type=script&lang=js"

import "./RecipeManager.vue?vue&type=style&index=0&id=bec67350&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bec67350"]])

export default __exports__